export const dnldWAUserMang = (builder) => ({
    dnldWAUserMang: builder.mutation({
        query: ({  status, loggedin_user_id, user_type_id, msisdn, startDate, endDate }) => {
            return {
                url: '/downloadUserManagementSummary',
                method: 'GET',
                params: {  status, loggedin_user_id, user_type_id, msisdn, startDate, endDate  },
                headers: {
                    'Content-Type':  'text/csv', 
                },
                responseHandler: (response) => response.blob(),
            };
        },
    }),
});